// extracted by mini-css-extract-plugin
export var bodySections = "_cq-8";
export var gray = "_cq-7";
export var green = "_cq-4";
export var iconContainer = "_cq-9";
export var iconWidgetContainer = "_cq-1";
export var phoneIcon = "_cq-2";
export var red = "_cq-5";
export var statusDot = "_cq-3";
export var widgetContainer = "_cq-0";
export var yellow = "_cq-6";